import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 55%;
  padding: 0.5rem;

  & > .title {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 0.875rem;
    font-weight: 600;
    padding-bottom: 0.75rem;
  }

  & > .subtitle {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 0.875rem;
    font-weight: 400;
    padding-bottom: 0.75rem;
  }

  .pavement-content-tag {
    padding-top: 0.3rem;
  }
`;
